import { render, staticRenderFns } from "./collectorcopy.vue?vue&type=template&id=bdd3da5e&"
import script from "./collectorcopy.vue?vue&type=script&lang=ts&"
export * from "./collectorcopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "collectorcopy.vue"
export default component.exports